module.exports = __webpack_public_path__ + "img/slip_scan.90fcd18.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/slip_scan.svg
// module id = d5lm
// module chunks = 1